module.exports = __webpack_public_path__ + "media/images/ecalls/06_fausto_frame_cloud_bottom-611eb99734a3fc0c378e970c0b02bb62.png";